export enum IntegrationCategoryType {
    Undefined = 0,
    SSO = 1,
    PublicAPI = 2,
    Payment = 3,
    Webinar = 4
}
